<div class="modal-header">
  <h5 class="modal-title" id="profileModalTitle">{{headerText}}</h5>
  <button type="button" (click)="dismiss()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  <form [formGroup]="manageAdminForm">
    <div class="row gx-3">
      <div class="col-md-6 mb-3">
        <label for="userFirstName" class="form-label">First Name<sup class="text-danger">*</sup></label>
        <input type="text" class="form-control" id="userFirstName" placeholder="First Name" formControlName="firstName"
          autofocus>
        <div *ngIf="firstNameCtrl.invalid && (firstNameCtrl.dirty || firstNameCtrl.touched)">
          <i class="fas fa-exclamation-circle"></i> This field is required.
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <label for="userLastName" class="form-label">Last Name<sup class="text-danger">*</sup></label>
        <input type="text" class="form-control" id="userLastName" placeholder="Last Name" formControlName="lastName">
        <div *ngIf="lastNameCtrl.invalid && (lastNameCtrl.dirty || lastNameCtrl.touched)">
          <i class="fas fa-exclamation-circle"></i> This field is required.
        </div>
      </div>
    </div>
    <div class="row gx-3">
      <div class="col-12 mb-3">
        <label for="userEmail" class="form-label">Email Address<sup class="text-danger">*</sup></label>
        <input type="email" class="form-control" id="userEmail" placeholder="Email Address"
          formControlName="emailAddress">
        <div *ngIf="emailAddressCtrl.invalid && (emailAddressCtrl.dirty || emailAddressCtrl.touched)">
          <div *ngIf="emailAddressCtrl.errors?.required">
            <i class="fas fa-exclamation-circle"></i> This Field is Required
          </div>
          <div *ngIf="emailAddressCtrl.errors?.email">
            <i class="fas fa-exclamation-circle"></i> Must be a valid email.
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!hideStatusToggle" class="row gx-3">
      <div class="col-md-6 mb-3">
        <label for="memberStatus" class="form-label d-block">Status</label>
        <select class="form-select" id="memberStatus" formControlName="isActive" aria-label="member status">
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" (click)="saveAdmin()" [disabled]="isBusy"
    class="btn btn-sb border-lb text-strong text-uppercase m-100">Save</button>
  <button type="button" (click)="dismiss()" class="btn btn-cancel text-strong text-uppercase m-100"
    data-bs-dismiss="modal">Cancel</button>
</div>